export default __webpack_public_path__ + "static/media/info.83d5809e.svg";